import React, { useState } from "react"
import { useAppSelector } from "@/app/redux/hooks/reduxHooks"
import { LEADERBOARD, LeaderboardProps, LEADERBOARDVIEW } from "@/types/types.leaderboards"
import { fetchLeaderboardsByStatisticNameByNumber } from "@/app/dashboard/dashboardAction"
import { toast } from "react-toastify"
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md"

type Props = {
    sessionTicket: string
    setResponse: React.Dispatch<React.SetStateAction<LeaderboardProps[]>>
    startingPosition: number
    setStartingPosition: React.Dispatch<React.SetStateAction<number>>
    maxResultsCount: number
    currentLeaderboard: string
    setCurrentLeaderboard: React.Dispatch<React.SetStateAction<string>>
    currentRankings: string
    responseLength: number
    setCurrentRankings: React.Dispatch<React.SetStateAction<string>>
}

const LeaderboardToggleComponent: React.FC<Props> = (props) => {
    const {
        sessionTicket,
        setResponse,
        startingPosition,
        setStartingPosition,
        maxResultsCount,
        currentLeaderboard,
        setCurrentLeaderboard,
        currentRankings,
        setCurrentRankings,
        responseLength,
    } = props
    const auth = useAppSelector((state) => state.auth)

    const fetchLeaderboardByNumber = async (modifier: string) => {
        const newStartingPosition =
            modifier === "increment" ? startingPosition + maxResultsCount : startingPosition - maxResultsCount
        const response = await fetchLeaderboardsByStatisticNameByNumber(
            currentLeaderboard,
            sessionTicket,
            maxResultsCount,
            newStartingPosition
        )
        if (!response.success) return toast.error(`Error fetching leaderboard: ${response.data}`)
        setResponse(response.data.data.Leaderboard)
        setStartingPosition(newStartingPosition)
    }

    return (
        <section className="block sm:flex items-center justify-start gap-5">
            <div>
                <select
                    className="text-black font-bold py-1 pr-10"
                    onChange={(e) => setCurrentLeaderboard(e.target.value)}
                >
                    <option value={LEADERBOARDVIEW.DAILY}>Daily Merit</option>
                    <option value={LEADERBOARDVIEW.MARKS}>Marks</option>
                    <option value={LEADERBOARDVIEW.MERIT}>Merit</option>
                    <option value={LEADERBOARDVIEW.VALOR}>Valor</option>
                </select>
            </div>
            <div className="flex gap-5 mt-3">
                {auth.isUserSignedIn && (
                    <div>
                        <button
                            className={`${currentRankings === LEADERBOARD.FETCHAROUNDPLAYER && "font-bold"}`}
                            onClick={() => setCurrentRankings(LEADERBOARD.FETCHAROUNDPLAYER)}
                        >
                            Your Ranking
                        </button>
                    </div>
                )}
                <div>
                    <button
                        className={`${currentRankings === LEADERBOARD.FETCHBYNUMBER && "font-bold"}`}
                        onClick={() => setCurrentRankings(LEADERBOARD.FETCHBYNUMBER)}
                    >
                        All Ranking
                    </button>
                </div>
                {currentRankings === LEADERBOARD.FETCHBYNUMBER && (
                    <div className="flex gap-3">
                        {startingPosition > 0 && (
                            <div>
                                <MdKeyboardDoubleArrowLeft
                                    className="relative top-[3px] cursor-pointer hover:text-primary transition-all"
                                    onClick={() => fetchLeaderboardByNumber("decrement")}
                                />
                            </div>
                        )}
                        <div>
                            {startingPosition + 1} - {responseLength + startingPosition}
                        </div>
                        {responseLength === maxResultsCount && (
                            <div>
                                <MdKeyboardDoubleArrowRight
                                    className="relative top-[3px] cursor-pointer hover:text-primary transition-all"
                                    onClick={() => fetchLeaderboardByNumber("increment")}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </section>
    )
}

export default LeaderboardToggleComponent
